import { render, staticRenderFns } from "./DetailCreateTable.vue?vue&type=template&id=0f1e233e&scoped=true"
import script from "./DetailCreateTable.vue?vue&type=script&lang=js"
export * from "./DetailCreateTable.vue?vue&type=script&lang=js"
import style0 from "./DetailCreateTable.vue?vue&type=style&index=0&id=0f1e233e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1e233e",
  null
  
)

export default component.exports